const translations = {
  es: {
    // Traducción de elementos en el navbar (barra de navegación)
    navbar: {
      title: "Inicio",
      option1: "Sobre el proyecto",
      option2: "¿Qué hacemos?",
      news: "Noticias",
      geoportal: "Geoportal",
      contacts: "Contactos",
    },

    // Traducción del título principal de la página
    mainTitle: "Sembrando tecnología, cosechando futuro",
    mainTitle2: "Innovar para cultivar con conciencia",
    mainTitle3: "Más allá del cultivo",

    mainSubTitle: "Agricultura inteligente para comunidades resilientes",
    mainSubTitle2: "Sostenibilidad y tecnología al servicio del agricultor",
    mainSubTitle3: "Cómo la pitahaya impulsa inclusión, ingresos y esperanza",

    buttonText1: "Conoce más",
    projectTitle: "Nuestro Proyecto",

    // Descripción del proyecto
    projectDescription1: "Es una iniciativa que busca revolucionar la producción agrícola a través del uso de tecnologías avanzadas. Nuestro enfoque combina: ",
    projectsubDescription1: "Monitoreo Remoto",
    projectsubDescription2: "Inteligencia Artificial",
    projectsubDescription3: "Análisis de Datos",
    projectDescription2: "Optimizamos el rendimiento durante la cosecha de cultivos y reducimos la desigualdad en comunidades rurales en el Ecuador.",

    aboutProject: "Sobre el proyecto",

    newThemeTitle: "Objetivo Principal",
    newThemeDescription: "Desarrollar e implementar un modelo de agricultura inteligente que permita mejorar la productividad del cultivo de pitahaya, optimizar el uso de recursos y evaluar el impacto social y económico en la reducción de la pobreza y la desigualdad.",

    buttonText2: "Como lo hacemos",

    newLines: "Líneas de Investigación",
    newLinesDescription1: "Integración de sensores y monitoreo remoto para evaluar la salud del cultivo.",
    newLinesDescription2: "Aplicación de inteligencia artificial para el análisis predictivo.",
    newLinesDescription3: "Uso eficiente del agua y reducción del impacto ambiental.",
    newLinesDescription4: "Desarrollo de metodologías escalables para pequeños y medianos productores.",

    // Auspiciante
    newSponsorTitle: "Auspiciante",
    newSponsorDescription: "El desarrollo de este proyecto ha sido posible gracias al apoyo de VLIR-UOS a través de un Short Initiative, un programa que impulsa la cooperación académica entre instituciones de Bélgica y países en desarrollo. Este financiamiento ha permitido la integración de tecnología avanzada en la agricultura, promoviendo el uso de inteligencia artificial, monitoreo remoto y procesamiento de datos multiespectrales para mejorar la productividad y sostenibilidad de los cultivos. Nuestro compromiso es generar un impacto positivo en el sector agrícola, contribuyendo a la innovación y fortaleciendo las capacidades locales mediante investigación aplicada y colaboración internacional.",

    // Títulos de las secciones de participantes
    universitiesTitle: "Universidades Participantes",
    researchGroupsTitle: "Grupos de Investigación",
    collaboratingEntitiesTitle: "Entidades Colaboradoras",

    // Títulos de la galería y del equipo
    teamTitle: "Colaboradores",
    
    // Cargos de los miembros del equipo (NUEVO)
    teamPositions: {
      "Patrick Vandewalle": "Director Belgica",
      "Esteban Valencia": "Director Ecuador",
      "Jackeline Abad": "Colaboradora del Proyecto",
      "Jenny Ávila": "Colaboradora del Proyecto",
      "Cristina Romero": "Colaboradora del Proyecto",
    },
    
    // Biografías de los miembros del equipo
    teamMembers: {
      "Patrick Vandewalle": "Patrick Vandewalle es Profesor Asociado en KU Leuven, Bélgica, especializado en imagen computacional y visión artificial.",
      "Esteban Valencia": "Esteban Valencia, Ingeniero Mecánico de la EPN con Maestría en Aeroespacial y Doctorado en Potencia y Propulsión.",
      "Jackeline Abad": "Profesora Asociada en la EPN, tiene maestría y doctorado en Ingeniería Eléctrica de la Universidad Estatal de Washington.",
      "Jenny Ávila": "Jenny Ávila Vélez, Máster en Ciencia de los Alimentos, analiza pitahaya en granjas piloto, optimizando la gestión de cultivos.",
      "Cristina Romero": "Cristina Romero es PhD en Economía Agrícola y Desarrollo Rural y desde 2016 es docente en la Escuela Politécnica Nacional en Quito."
    },

    // Traducción de las noticias
    noticias: {
      news: "Noticias",
      readMore: "Leer más",
      readLess: "Leer menos",
    },

    // Traducción de testimonios
    whatWeDoDescription: "Aprovechamos tecnología avanzada para optimizar la producción agrícola. \n A través de drones, sensores multiespectrales e inteligencia artificial, analizamos el estado del cultivo y generamos estrategias para su mejor desarrollo.",

    testimonios: {
      title1: "Análisis del cultivo y planificación del monitoreo",
      content1: "Se evalúan las necesidades del cultivo para definir los objetivos del monitoreo. Se identifican las variables clave a observar y se establecen estrategias para un seguimiento eficiente.",
      title2: "Reconocimiento del cultivo y puntos estratégicos",
      content2: "Se seleccionan áreas clave considerando la distribución del cultivo, la variabilidad del terreno y el acceso a zonas críticas. Esto garantiza una recolección de datos representativa y precisa.",
      title3: "Monitoreo con drones y captura de datos",
      content3: "Se ejecutan vuelos planificados con drones equipados con sensores multiespectrales para capturar imágenes de alta resolución, permitiendo evaluar el estado del cultivo y detectar posibles anomalías.",
      title4: "Procesamiento y análisis de datos",
      content4: "Se emplean herramientas como QGIS e inteligencia artificial para analizar las imágenes capturadas. Se generan mapas e indicadores clave que facilitan la interpretación de los datos.",
      title5: "Socialización de resultados y toma de decisiones",
      content5: "Los hallazgos se comparten con agricultores y expertos para optimizar estrategias de manejo. Se generan recomendaciones basadas en datos para mejorar la productividad y sostenibilidad del cultivo.",
    },

    // Traducción de los iconos con título y descripción
    icons: {
      icon1: {
        title: "Icono de Agricultura",
        description: "Este icono representa la agricultura sostenible y las tecnologías aplicadas a la gestión agrícola."
      },
      icon2: {
        title: "Icono de Tecnología",
        description: "Este icono simboliza la innovación tecnológica que mejora la eficiencia en el sector agrícola."
      },
      icon3: {
        title: "Icono de Innovación",
        description: "Representa las innovaciones en el campo agrícola que permiten una mejor toma de decisiones y productividad."
      },
      icon4: {
        title: "Icono de Colaboración",
        description: "Este icono refleja el trabajo en equipo y la colaboración entre expertos para lograr los objetivos del proyecto."
      },
    },

    // geoportal
    geoForm: "Regístrate para acceder al Geoportal",
    geoFormName: "Nombre",
    geoFormEmail: "Correo electrónico",
    geoFormPhone: "Teléfono",
    geoFormCity: "Ciudad",
    geoFormLabel: "¿Te gustaría vincularte a la comunidad?",
    geoFormButton: "Enviar",

    // contactos
    contactTitle: "Contáctanos",
    location: "Ubicación",
    email: "Correo Electrónico",
    phone: "Teléfono",
    locationDescription1: "Grupo de investigación ATA-EPN",
    locationDescription2: "Laboratorio de UAV´s",
    contactQr: "Escanea el código para más información",
    followUs: "Síguenos en nuestras redes sociales", 

    // footer
    or: "o",
    copyright: 'ATA. Todos los derechos reservados.',
    quickLinks: 'Enlaces rápidos:',
    home: 'Inicio',
    aboutUs: 'Sobre el proyecto',
    whatWeDo: '¿Qué hacemos?',
    news: 'Noticias',
    geoportal: 'Geoportal',
    contactUs: 'Contactos',
  },

  en: {
    // Traducción de elementos en el navbar (barra de navegación)
    navbar: {
      title: "Home",
      option1: "About the project",
      option2: "What do we do?",
      news: "News",
      geoportal: "Geoportal",
      contacts: "Contacts",
    },

    // Traducción del título principal de la página
    mainTitle: "Sowing Technology, Harvesting Future",
    mainTitle2: "Innovating for Conscious Cultivation",
    mainTitle3: "Beyond Cultivation",

    mainSubTitle: "Smart agriculture for resilient communities",
    mainSubTitle2: "Sustainability and technology at the service of farmers",
    mainSubTitle3: "How pitahaya fosters inclusion, income, and hope",
    
    projectTitle: "Our Project",
    
    // Descripción del proyecto
    projectDescription1: "It is an initiative that seeks to revolutionize agricultural production through the use of advanced technologies. Our approach combines: ",
    projectsubDescription1: "Remote Monitoring",
    projectsubDescription2: "Artificial Intelligence",
    projectsubDescription3: "Data Analysis",
    projectDescription2: "We optimize performance during crop harvest and reduce inequality in rural communities in Ecuador.",

    buttonText1: "Learn more",

    aboutProject: "About the project",

    newThemeTitle: "Main Objective",
    newThemeDescription: "Develop and implement a smart agriculture model to improve dragon fruit crop productivity, optimize resource use, and evaluate the social and economic impact in reducing poverty and inequality.",

    buttonText2: "How we do it",

    newLines: "Research Lines",
    newLinesDescription1: "Integration of sensors and remote monitoring to assess crop health.",
    newLinesDescription2: "Application of artificial intelligence for predictive analysis.",
    newLinesDescription3: "Efficient water use and reduction of environmental impact.",
    newLinesDescription4: "Development of scalable methods for small and medium producers.",

    // Auspiciante
    newSponsorTitle: "Sponsor",
    newSponsorDescription: "The development of this project has been made possible thanks to the support of VLIR-UOS through a Short Initiative, a program that promotes academic cooperation between Belgian institutions and developing countries. This funding has enabled the integration of advanced technology in agriculture, fostering the use of artificial intelligence, remote monitoring, and multispectral data processing to enhance crop productivity and sustainability. Our commitment is to create a positive impact in the agricultural sector, contributing to innovation and strengthening local capacities through applied research and international collaboration.",

    // Títulos de las secciones de participantes
    universitiesTitle: "Participating Universities",
    researchGroupsTitle: "Research Groups",
    collaboratingEntitiesTitle: "Collaborating Entities",

    // Títulos de la galería y del equipo
    galleryTitle: "Innovation Gallery",
    teamTitle: "Collaborators",

    // Cargos de los miembros del equipo en inglés (NUEVO)
    teamPositions: {
      "Patrick Vandewalle": "Belgian Promoter",
      "Esteban Valencia": "Partner Promoter",
      "Jackeline Abad": "Project Collaborator",
      "Jenny Ávila": "Project Collaborator",
      "Cristina Romero": "Project Collaborator",
    },

    // Biografías de los miembros del equipo en inglés
    teamMembers: {
      "Patrick Vandewalle": "Patrick Vandewalle is an Associate Professor at KU Leuven, Belgium, specializing in computer vision and image processing.",
      "Esteban Valencia": "Esteban Valencia, Mechanical Engineer from EPN with a Master's in Aerospace and a PhD in Power and Propulsion.",
      "Jackeline Abad": "Associate Professor at EPN, holds a Master's and PhD in Electrical Engineering from Washington State University.",
      "Jenny Ávila": "Jenny Ávila Vélez, Master's in Food Science, analyzes pitahaya in pilot farms, optimizing crop management.",
      "Cristina Romero": "Cristina Romero is a PhD in Agricultural Economics and Rural Development and has been teaching at the Escuela Politécnica Nacional since 2016."
    },

    // Traducción de las noticias
    noticias: {
      news: "News",
      readMore: "Read more",
      readLess: "Read less",
    },

    // Traducción de testimonios
    whatWeDoDescription: "We leverage advanced technology to optimize agricultural production. \n Through drones, multispectral sensors, and artificial intelligence, we analyze crop conditions and generate strategies for better development.",

    testimonios: {
      title1: "Crop Analysis and Monitoring Planning",
      content1: "The crop's needs are assessed to define monitoring objectives. Key variables to observe are identified, and strategies are established for efficient tracking.",
      title2: "Crop Recognition and Key Points Selection",
      content2: "Strategic areas are selected based on crop distribution, terrain variability, and access to critical zones. This ensures representative and accurate data collection.",
      title3: "Drone Monitoring and Data Capture",
      content3: "Planned drone flights are conducted using multispectral sensors to capture high-resolution images, enabling crop condition assessment and early anomaly detection.",
      title4: "Data Processing and Analysis",
      content4: "Tools like QGIS and artificial intelligence are used to analyze the captured images. Maps and key indicators are generated to facilitate data interpretation.",
      title5: "Results Sharing and Decision-Making",
      content5: "Findings are shared with farmers and experts to optimize management strategies. Data-driven recommendations are provided to enhance crop productivity and sustainability.",
    },

    // Traducción de los iconos con título y descripción
    icons: {
      icon1: {
        title: "Agriculture Icon",
        description: "This icon represents sustainable agriculture and technologies applied to agricultural management."
      },
      icon2: {
        title: "Technology Icon",
        description: "This icon symbolizes technological innovation that improves efficiency in the agricultural sector."
      },
      icon3: {
        title: "Innovation Icon",
        description: "Represents innovations in agriculture that enable better decision-making and productivity."
      },
      icon4: {
        title: "Collaboration Icon",
        description: "This icon reflects teamwork and collaboration among experts to achieve the project's goals."
      },
    },

    // traduccion geoportal
    geoForm: "Register to access the Geoportal",
    geoFormName: "Name",
    geoFormEmail: "Email",
    geoFormPhone: "Phone",
    geoFormCity: "City",
    geoFormLabel: "Would you like to join the community?",
    geoFormButton: "Submit",

    // traduccion contactos
    contactTitle: "Contact Us",
    location: "Location",
    locationDescription1: "ATA-EPN Research Group",
    locationDescription2: "UAV´s Laboratory",
    email: "Email",
    phone: "Phone",
    contactQr: "Scan the code for more information",
    followUs: "Follow us on our social media",

    // footer
    or: "or",
    copyright: 'ATA. All rights reserved.',
    quickLinks: 'Quick links:',
    home: 'Home',
    aboutUs: 'About the project',
    whatWeDo: 'What do we do?',
    news: 'News',
    geoportal: 'Geoportal',
    contactUs: 'Contacts',
  }
};

export default translations;